import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Gamepad2 } from 'lucide-react';

const levels = [
  { v: 0, label: 'Just Browsing', color: '#2A9D8F', desc: 'Cool cool. A tiny nibble. No pressure.' },
  { v: 50, label: 'Snack Attack', color: '#F4A300', desc: 'You know what you want. Time to crunch.' },
  { v: 100, label: 'Full Crunch Mode', color: '#E63946', desc: 'Okay. You\u2019re ready. Play the game.' }
];

const CrunchLevel = () => {
  const [val, setVal] = useState(50);
  const current = levels.reduce((acc, l) => (val >= l.v ? l : acc), levels[0]);

  return (
    <section className="px-5 md:px-8 py-16 md:py-24">
      <div className="max-w-4xl mx-auto text-center">
        <div className="text-xs font-bold uppercase tracking-widest text-[#E63946]">Vibe check</div>
        <h2 className="font-display text-5xl md:text-7xl uppercase leading-[0.9] mt-2">
          How crunchy<br />are you?
        </h2>

        <div className="mt-10 bg-white rounded-3xl crunch-shadow p-8 md:p-10">
          <div className="font-display text-4xl md:text-5xl uppercase" style={{ color: current.color }}>
            {current.label}
          </div>
          <p className="font-brico text-lg mt-2 opacity-70">{current.desc}</p>

          <div className="mt-8 relative">
            <input
              type="range"
              min="0"
              max="100"
              value={val}
              onChange={(e) => setVal(Number(e.target.value))}
              className="w-full h-3 rounded-full appearance-none cursor-pointer"
              style={{ background: `linear-gradient(to right, #2A9D8F 0%, #F4A300 50%, #E63946 100%)` }}
            />
            <div className="flex justify-between mt-4 text-xs font-bold uppercase opacity-70">
              {levels.map((l) => <span key={l.v}>{l.label}</span>)}
            </div>
          </div>

          <Link to="/play" className="btn-chunky primary mt-8">
            <Gamepad2 size={18} /> Play the Game
          </Link>
        </div>
      </div>

      <style>{`
        input[type="range"]::-webkit-slider-thumb {
          -webkit-appearance: none;
          width: 28px; height: 28px; border-radius: 999px;
          background: #1a1a1a; border: 3px solid #FFF4E6;
          box-shadow: 3px 3px 0 rgba(0,0,0,0.5); cursor: pointer;
        }
        input[type="range"]::-moz-range-thumb {
          width: 28px; height: 28px; border-radius: 999px;
          background: #1a1a1a; border: 3px solid #FFF4E6; cursor: pointer;
        }
      `}</style>
    </section>
  );
};

export default CrunchLevel;
